import { render, staticRenderFns } from "./ReceiptView.vue?vue&type=template&id=634dee1b&scoped=true&"
import script from "./ReceiptView.vue?vue&type=script&lang=ts&"
export * from "./ReceiptView.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptView.vue?vue&type=style&index=0&id=634dee1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dee1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
